import { render, staticRenderFns } from "./DigitalHumanV2.vue?vue&type=template&id=4ae7e23d&scoped=true&"
import script from "./DigitalHumanV2.vue?vue&type=script&lang=ts&"
export * from "./DigitalHumanV2.vue?vue&type=script&lang=ts&"
import style0 from "./DigitalHumanV2.vue?vue&type=style&index=0&id=4ae7e23d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ae7e23d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VImg})
